import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

import { merge, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AssetDAO, DaoFactory, Path } from '@data';

@Injectable()
export class AssetService {
  constructor(
    private daoFactory: DaoFactory,
    private firebaseFunctions: Functions,
  ) {}

  getAsset(locId: string, assetId: string): Observable<AssetDAO> {
    const mfgAsset = this.daoFactory.build(AssetDAO, Path.asset(locId, assetId));
    const unclaimedAsset = this.daoFactory.build(AssetDAO, Path.unclaimedAsset(assetId));
    return merge(mfgAsset, unclaimedAsset).pipe(filter((x) => x != null));
  }

  async resetAsset(params: { mac: string; locId: string }) {
    const resetAsset = httpsCallable(this.firebaseFunctions, 'resetAsset');
    await resetAsset(params);
  }
}
